import Factory from '../utils/factory'
import Address from '../Address'
import Shared from '../ResidentialTemplate/shared'


const shared = Shared()
export default Factory({
  id: null,
  number: null,
  displayName: null,
  status: 'draft',
  cadastre: null,
  redirectUrl: null,
  address: Address(),
  owners: null,
  reservedBy: null,
  customFields: null,
  customFieldsConfig: [],
  ...shared,
  sale: {
    ...shared.sale,
    type: 'sale',
    bidUrl: null,

  }
})
